import APIService from 'services/APIService'
import qs from 'query-string'
import { omit } from 'ramda'

const api = APIService()

export const fetchUserUnits = ({ sort, page, filters }) =>
  api.get(
    `/building-passport/units?${qs.stringify({ sort })}&page=${page}${filters || ''}`
  )
export const fetchBpUnits = payload =>
  api.get(`/building-passport/${payload.bpId}/units`)
export const addManualBpUnits = payload =>
  api.post(`/building-passport/${payload.bpId}/units`, {
    units: payload.units
  })
export const fetchNoticeBoard = payload =>
  api.get(`/building-passport/${payload.bpId}/notice-board`)
export const fetchUnit = payload =>
  api.get(`/building-passport/${payload.bpId}/units/${payload.unitId}`)
export const syncUnitEpc = ({ bpId, unitId }) =>
  api.post(`/building-passport/${bpId}/units/${unitId}/epc/sync`)
export const getUnitEpcStatus = ({ bpId, unitId }) =>
  api.get(`/building-passport/${bpId}/units/${unitId}/epc/status`)
export const addBpUnits = payload =>
  api.post(`/building-passport/${payload.bpId}/units/generate`, payload)
export const editBpUnit = payload =>
  api.patch(`/building-passport/${payload.bpId}/units/${payload.id}`, {
    ...payload
  })
export const patchBpUnit = ({ bpId, unitId, patch }) =>
  api.patch(`/building-passport/${bpId}/units/${unitId}`, patch)
export const removeBpUnit = payload =>
  api.delete(`/building-passport/${payload.bpId}/units/${payload.unitId}`)
export const removeBpUnitsWithoutUprn = payload =>
  api.delete(`/building-passport/${payload.bpId}/units/without-uprn`)
export const fetchUnitRevertPoint = payload =>
  api.get(`/building-passport/${payload.bpId}/units/revert-point`)
export const createUnitRevertPoint = payload =>
  api.post(`/building-passport/${payload.bpId}/units/revert-point`, {
    label: payload.label
  })
export const revertUnitsToRevertPoint = payload =>
  api.post(`/building-passport/${payload.bpId}/units/revert-point/revert`)
export const editUserRelationToUnit = payload =>
  api.patch(
    `/building-passport/${payload.bpId}/units/${payload.unitId}/assigned-users/${payload.userId}`,
    { ...payload.body }
  )
export const assignUserToUnit = payload =>
  api.post(
    `/building-passport/${payload.bpId}/units/${payload.unitId}/assigned-users`,
    { ...payload.body }
  )
export const revokeAccessToUnit = ({ bpId, unitId, relationId }) =>
  api.patch(
    `/building-passport/${bpId}/units/${unitId}/assigned-users/${relationId}/revoke`
  )
export const reactivateUnitUser = payload =>
  api.patch(
    `/building-passport/${payload.bpId}/units/${payload.unitId}/assigned-users/${payload.relationId}/reactivate`
  )
export const detachUnitUser = payload =>
  api.delete(
    `/building-passport/${payload.bpId}/units/${payload.unitId}/assigned-users/${payload.relationId}`
  )
export const getUserRelationToUnit = payload =>
  api.get(
    `/building-passport/${payload.bpId}/units/${payload.unitId}/assigned-users/roles?user_id=${payload.userId}`
  )
export const approveInvitation = ({ bpId, unitId, invitationId }) =>
  api.post(
    `/building-passport/${bpId}/units/${unitId}/invitations/${invitationId}/approve`
  )
export const denyInvitation = ({ bpId, unitId, invitationId }) =>
  api.delete(
    `/building-passport/${bpId}/units/${unitId}/invitations/${invitationId}`
  )
export const deleteAccessRequest = ({ bpId, unitId, requestId, reason }) =>
  api.delete(
    `/building-passport/${bpId}/units/${unitId}/access-requests/${requestId}`,
    { data: { reason } }
  )
export const inviteUserToUnit = payload =>
  api.post(
    `/building-passport/${payload.bpId}/units/${payload.unitId}/invitations`,
    { ...payload.body }
  )
export const getUnitInvitation = payload =>
  api.get(
    `/building-passport/unit-invitations/${payload.id}?email=${payload.email}`
  )
export const fetchUnitInvitationsList = payload =>
  api.get(
    `/building-passport/${payload.bpId}/units/${payload.unitId}/invitations`
  )
export const cancelUnitInvitation = payload =>
  api.delete(
    `/building-passport/${payload.bpId}/units/${payload.unitId}/invitations/${payload.invitationId}`
  )
export const requestAccessToUnit = payload =>
  api.post(
    `/building-passport/${payload.bpId}/units/${payload.unitId}/access-requests`,
    payload
  )
export const getUnitAccessRequests = payload =>
  api.get(
    `/building-passport/${payload.bpId}/units/${payload.unitId}/access-requests`
  )
export const acceptUnitAccessRequest = payload =>
  api.patch(
    `/building-passport/${payload.bpId}/units/${payload.unitId}/access-requests/${payload.requestId}/accept`
  )
export const approveRequest = ({ bpId, unitId, requestId }) =>
  api.patch(
    `/building-passport/${bpId}/units/${unitId}/access-requests/${requestId}/accept`
  )
export const denyUnitAccessRequest = payload =>
  api.delete(
    `/building-passport/${payload.bpId}/units/${payload.unitId}/access-requests/${payload.requestId}`,
    payload
  )

export const syncUnits = payload =>
  api.post(`/building-passport/${payload.bpId}/units/sync`, {
    selected_uprns: payload.selectedUprns || null
  })
export const previewUnitSync = payload =>
  api.post(`/building-passport/${payload.bpId}/units/sync-preview`, {
    selected_uprns: payload.selectedUprns || null
  })
export const previewUnitReconciliation = payload => {
  const body = {
    selected_uprns: payload.selectedUprns || null
  }

  return payload.selectedUprns?.length
    ? api.post(
        `/building-passport/${payload.bpId}/units/reconciliation-preview`,
        body
      )
    : api.get(`/building-passport/${payload.bpId}/units/reconciliation-preview`, {
        params: body
      })
}
export const lookupUnitReconciliationPostcodes = payload =>
  api.post(
    `/building-passport/${payload.bpId}/units/reconciliation-postcode-lookup`,
    {
      selected_uprns: payload.selectedUprns || [],
      target_uprns: payload.targetUprns || [],
      postcodes: payload.postcodes || []
    }
  )
export const applyUnitReconciliationMatches = payload =>
  api.patch(`/building-passport/${payload.bpId}/units/reconciliation-matches`, {
    matches: payload.matches || []
  })
export const updateUnitReconciliationIgnores = payload =>
  api.patch(`/building-passport/${payload.bpId}/units/reconciliation-ignores`, {
    action: payload.action,
    uprns: payload.uprns || []
  })
export const updateUnitSyncPromptState = payload =>
  api.patch(`/building-passport/${payload.bpId}/units/sync-prompt-state`, {
    event: payload.event
  })
export const fetchBpUnitsForAccessRequest = payload =>
  api.get(`/building-passport/${payload.bpId}/access-requests/units`)
export const getFloorPlansForUnit = payload =>
  api.get(
    `/building-passport/${payload.bpId}/units/${payload.unitId}/files/floor-plans`
  )
export const addFileToUnit = payload =>
  api.post(
    `/building-passport/${payload.bpId}/units/${payload.unitId}/files`,
    omit(['bpId', 'unitId'], payload)
  )

export const updateUnitFile = payload =>
  api.patch(
    `/building-passport/${payload.bpId}/units/${payload.unitId}/files/${payload.fileId}/${payload.fileVersionId}`,
    payload.body
  )
export const removeUnitFile = payload =>
  api.delete(
    `/building-passport/${payload.bpId}/units/${payload.unitId}/files/${payload.fileId}`
  )
export const addUnitFileVersion = payload => {
  const { bpId, unitId, fileId } = payload
  return api.post(
    `building-passport/${bpId}/units/${unitId}/files/${fileId}/version`,
    omit(['bpId', 'unitId', 'fileId'], payload)
  )
}
export const removeUnitFileVersion = payload => {
  const { bpId, unitId, fileId, fileVersionId } = payload
  return api.delete(
    `/building-passport/${bpId}/units/${unitId}/files/${fileId}/${fileVersionId}`
  )
}

export const reorderUnitFileVersions = payload => {
  const { bpId, unitId, fileId, versionsOrder } = payload
  return api.patch(
    `/building-passport/${bpId}/units/${unitId}/files/${fileId}/versions-order`,
    { versionsOrder }
  )
}

export const getRequests = (bpId, unitId) =>
  api.get(`/building-passport/${bpId}/units/${unitId}/access-requests`)

export const getInvitations = (bpId, unitId) =>
  api.get(`/building-passport/${bpId}/units/${unitId}/invitations`)

export const getRevoked = (bpId, unitId) =>
  api.get(`/building-passport/${bpId}/units/${unitId}/assigned-users/revoked`)

export const reactivateAccessToUnit = ({ bpId, unitId, relationId }) =>
  api.patch(
    `/building-passport/${bpId}/units/${unitId}/assigned-users/${relationId}/reactivate`
  )

export const deleteAccessToUnit = ({ bpId, unitId, relationId }) =>
  api.delete(
    `/building-passport/${bpId}/units/${unitId}/assigned-users/${relationId}`
  )
export const fetchUnitDetails = ({ bpId, unitId }) =>
  api.get(`/building-passport/${bpId}/units/${unitId}`)
